/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  UpdateProjectProjectSizeEnum,
  UpdateProjectProjectTypeEnum,
} from '@ansvar-sakerhet/api-client';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import React from 'react';
import { Select } from '../../../../components/Select';
import { useFindAllUsersFrameCompany } from '../../../../traits/api/frameCompany/useFindAllUsersFrameCompany';
import { S } from './MyProject.styles';
type Props = {
  onCancel: () => void;
  projectName: string;
  setProjectName: (name: string) => void;
  canRename: boolean;
  projectType: 'Bank' | 'CSRD' | 'Custom' | undefined;
  projectSize: 'Small' | 'Medium' | 'Large' | undefined;
  responsible: string;
  setResponsible: (responsible: string) => void;
  custom: number;
  updateProjectSize: (size: UpdateProjectProjectSizeEnum) => void;
  updateProjectType: (type: UpdateProjectProjectTypeEnum) => void;
  updateCustom: (custom: number) => void;
  save: () => void;
};

export const EditProjectSettings: React.FC<Props> = ({
  onCancel,
  projectName,
  setProjectName,
  canRename,
  projectType,
  projectSize,
  custom,
  responsible,
  setResponsible,
  updateProjectSize,
  updateProjectType,
  updateCustom,
  save,
}) => {
  const { data: frameCompanyUsers } = useFindAllUsersFrameCompany();
  return (
    <AlertDialog.Portal>
      <S.Overlay>
        <S.Wrapper>
          <S.CancelButton onClick={onCancel}>
            <S.Icon src="Close" width={24} height={24} />
          </S.CancelButton>

          <S.ContentContainer>
            {canRename && (
              <>
                <S.H5>Projektnamn</S.H5>
                <input
                  type="text"
                  value={projectName}
                  onChange={(e) => setProjectName(e.target.value)}
                  style={{ width: '100%', padding: 8, marginBottom: 16 }}
                />
              </>
            )}
            <S.H5>Välj ansvarig för projektet</S.H5>

            <Select
              label=""
              value={responsible === null ? undefined : responsible}
              onChange={(e) => setResponsible(e.target.value)}
            >
              {frameCompanyUsers?.customerUsers.map((user: any) => (
                <option key={user.customerUserId} value={user.customerUserId}>
                  {user.firstName} {user.lastName}
                </option>
              ))}
              <option key={'no_responsible'} value={'no_responsible'}>
                Ingen ansvarig
              </option>
            </Select>
            <AlertDialog.Title asChild>
              <S.H5>Vilken standard vill du följa?</S.H5>
            </AlertDialog.Title>
            <S.ButtonContainer>
              <S.Button
                $outlined={!(projectType === UpdateProjectProjectTypeEnum.Bank)}
                onClick={() =>
                  updateProjectType(UpdateProjectProjectTypeEnum.Bank)
                }
              >
                Bankinitativet
              </S.Button>
              <S.Button
                $outlined={!(projectType === UpdateProjectProjectTypeEnum.Csrd)}
                onClick={() =>
                  updateProjectType(UpdateProjectProjectTypeEnum.Csrd)
                }
              >
                CSRD
              </S.Button>
              <S.Button
                $outlined={
                  !(projectType === UpdateProjectProjectTypeEnum.Custom)
                }
                onClick={() =>
                  updateProjectType(UpdateProjectProjectTypeEnum.Custom)
                }
              >
                Egen
              </S.Button>
            </S.ButtonContainer>
            {projectType === UpdateProjectProjectTypeEnum.Custom && (
              <S.Section style={{ textAlign: 'center' }}>
                <S.H5>Antal månader mellan kontroller</S.H5>
                <S.Margin $vertical="s" />
                <input
                  style={{}}
                  type="number"
                  onChange={(e) => updateCustom(Number(e.target.value))}
                  value={custom}
                />
              </S.Section>
            )}
            <S.Margin $vertical="s" />
            {projectType === UpdateProjectProjectTypeEnum.Bank ||
            projectType === UpdateProjectProjectTypeEnum.Csrd ? (
              <>
                <AlertDialog.Title asChild>
                  <S.H5>Hur stort är projektet? (Msek)</S.H5>
                </AlertDialog.Title>
                <S.ButtonContainer>
                  {projectType === UpdateProjectProjectTypeEnum.Csrd && (
                    <S.Button
                      $outlined={
                        !(projectSize === UpdateProjectProjectSizeEnum.Small)
                      }
                      onClick={() =>
                        updateProjectSize(UpdateProjectProjectSizeEnum.Small)
                      }
                      style={{ width: '100%' }}
                    >
                      10-50
                    </S.Button>
                  )}

                  <S.Button
                    $outlined={
                      !(projectSize === UpdateProjectProjectSizeEnum.Medium)
                    }
                    onClick={() =>
                      updateProjectSize(UpdateProjectProjectSizeEnum.Medium)
                    }
                  >
                    {projectType === UpdateProjectProjectTypeEnum.Bank
                      ? '50-500'
                      : '50-250'}
                  </S.Button>
                  <S.Button
                    $outlined={
                      !(projectSize === UpdateProjectProjectSizeEnum.Large)
                    }
                    onClick={() =>
                      updateProjectSize(UpdateProjectProjectSizeEnum.Large)
                    }
                  >
                    {projectType === UpdateProjectProjectTypeEnum.Bank
                      ? '500+'
                      : '250+'}
                  </S.Button>
                </S.ButtonContainer>
              </>
            ) : null}

            <S.ButtonContainer>
              <AlertDialog.Cancel asChild>
                <S.Button $outlined onClick={onCancel}>
                  Avbryt
                </S.Button>
              </AlertDialog.Cancel>

              <AlertDialog.Action asChild>
                <S.Button onClick={() => save()}>Spara</S.Button>
              </AlertDialog.Action>
            </S.ButtonContainer>
          </S.ContentContainer>
        </S.Wrapper>
      </S.Overlay>
    </AlertDialog.Portal>
  );
};
